import differenceInDays from 'date-fns/differenceInDays';
import isAfter from 'date-fns/isAfter';
import {HelixSeriesStatus} from '../../../../graphql/generated/types';

export function verifyHelixExpireDate(date: Date) {
  const now = Date.now();

  if (!isAfter(now, date)) {
    return HelixSeriesStatus.Active;
  } else if (differenceInDays(now, date) < 7) {
    return HelixSeriesStatus.Closed;
  } else {
    return HelixSeriesStatus.Ended;
  }
}
